var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from "axios";
import { useEffect, useState } from "react";
import { useGlobalState } from "../store/store";
import { AssetsList } from "../store/types";
var getAssetPriceInUSD = function (currencyName) { return __awaiter(void 0, void 0, void 0, function () {
    var apiURL, response, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                apiURL = "https://api.coingecko.com/api/v3/simple/price?ids=" + currencyName + "&vs_currencies=usd";
                return [4 /*yield*/, axios.get(apiURL)];
            case 1:
                response = _a.sent();
                data = response.data;
                if (data && data[currencyName]) {
                    return [2 /*return*/, data[currencyName].usd];
                }
                return [2 /*return*/, 0];
        }
    });
}); };
var COINGECKO_CURRENCIES = {
    WETH: "ethereum",
    WBTC: "wrapped-bitcoin",
    USDC: "usd-coin",
    yvUSDC: "",
};
var useAssetPrice = function (_a) {
    var _b = _a.asset, asset = _b === void 0 ? "WETH" : _b;
    var _c = useGlobalState("prices"), prices = _c[0], setPrices = _c[1];
    var _d = useState(false), loading = _d[0], setLoading = _d[1];
    useEffect(function () {
        !prices[asset].fetched &&
            (function () { return __awaiter(void 0, void 0, void 0, function () {
                var price_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!AssetsList.includes(asset)) return [3 /*break*/, 2];
                            setLoading(true);
                            return [4 /*yield*/, getAssetPriceInUSD(COINGECKO_CURRENCIES[asset])];
                        case 1:
                            price_1 = _a.sent();
                            setPrices(function (prices) {
                                var _a;
                                return (__assign(__assign({}, prices), (_a = {}, _a[asset] = { price: price_1, fetched: true }, _a)));
                            });
                            setLoading(false);
                            return [3 /*break*/, 3];
                        case 2: throw new Error("Unknown asset " + asset);
                        case 3: return [2 /*return*/];
                    }
                });
            }); })();
    }, [asset, prices, setPrices]);
    return { price: prices[asset].price, loading: loading };
};
export default useAssetPrice;
export var useAssetsPrice = function (_a) {
    var _b = _a.assets, assets = _b === void 0 ? ["WETH"] : _b;
    var _c = useGlobalState("prices"), prices = _c[0], setPrices = _c[1];
    var _d = useState(false), loading = _d[0], setLoading = _d[1];
    useEffect(function () {
        setLoading(true);
        Promise.all(assets.map(function (asset) { return __awaiter(void 0, void 0, void 0, function () {
            var price_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (prices[asset].fetched) {
                            return [2 /*return*/];
                        }
                        if (!AssetsList.includes(asset)) return [3 /*break*/, 2];
                        setLoading(true);
                        return [4 /*yield*/, getAssetPriceInUSD(COINGECKO_CURRENCIES[asset])];
                    case 1:
                        price_2 = _a.sent();
                        setPrices(function (prices) {
                            var _a;
                            return (__assign(__assign({}, prices), (_a = {}, _a[asset] = {
                                price: price_2,
                                fetched: true,
                            }, _a)));
                        });
                        setLoading(false);
                        return [3 /*break*/, 3];
                    case 2: throw new Error("Unknown asset " + asset);
                    case 3: return [2 /*return*/];
                }
            });
        }); }));
        setLoading(false);
    }, [assets, prices, setPrices]);
    return {
        prices: Object.fromEntries(assets.map(function (asset) { return [asset, prices[asset].price]; })),
        loading: loading,
    };
};
//# sourceMappingURL=useAssetPrice.js.map